
import axios from 'axios';

const appService = {
    sendReport(report) {
        return new Promise((resolve, reject) => {
            // SC logicApps
            // axios.post('https://prod-32.northeurope.logic.azure.com:443/workflows/4c377e3eb26e40eea73e5f67f70aebf8/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=q7H43PZ8ZuoyYxsj7WoKlj1OBQH62bJ_ieJzxEKamWE', report)
             // Hausers LogicApps
            axios.post('https://prod-45.northeurope.logic.azure.com:443/workflows/6c056868d48e427d85a9105c198c7c45/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=H5lslFeAKtNTcW-yiH7pmhliFlMeNoD4usSpcqyEufY', report)
            // Hausers TEST-WarantyCases list:
            // axios.post('https://prod-51.northeurope.logic.azure.com:443/workflows/168543fe2c0d438b928fc8c961281b01/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=SIzqYEJkTooQKtHEB2ia9OO1VwbYbiBdgjjfYxRv7-M', report)
                .then(response => {
                    // setTimeout(function(){
                        resolve(response.data);
                    // }, 3000);
                })
                .catch(response => {
                    reject(response.status)
                    console.error(response);
                })
        })
    },
    getCountries() {
        return new Promise((resolve, reject) => {
            axios.get('https://restcountries.com/v3.1/all?fields=name,idd')
                .then(response => {
                    resolve(response.data)
                })
                .catch(response => {
                    reject(response.status)
                })
        })
    }
}
export default appService;
